import './style.scss'

export const CategoriesTitle = ({ children }) => (
  <div className="CategoriesTitle">{children}</div>
)
